import type { Tone } from "@/ui/Badge";

/** Where a set stands, in the estimator's words. */
export interface Standing {
  key: "failed" | "reading" | "running" | "ready" | "stopped" | "choose";
  label: string;
  tone: Tone;
}

export function standing(
  doc: { status: string },
  run: { status: string } | null | undefined,
): Standing {
  if (doc.status === "failed") {
    return { key: "failed", label: "Could not be read", tone: "danger" };
  }
  if (doc.status === "uploaded" || doc.status === "ingesting") {
    return { key: "reading", label: "Reading the set", tone: "accent" };
  }
  if (run && (run.status === "queued" || run.status === "running")) {
    return { key: "running", label: "Run in progress", tone: "accent" };
  }
  if (run?.status === "done") {
    return { key: "ready", label: "Take-off ready", tone: "ok" };
  }
  if (run) {
    return { key: "stopped", label: "Run stopped early", tone: "danger" };
  }
  return { key: "choose", label: "Sheets to choose", tone: "neutral" };
}

/** Every standing, in the order the Sets filter offers them. */
export const STANDINGS: readonly { key: Standing["key"]; label: string }[] = [
  { key: "ready", label: "Take-off ready" },
  { key: "running", label: "Run in progress" },
  { key: "choose", label: "Sheets to choose" },
  { key: "reading", label: "Reading the set" },
  { key: "stopped", label: "Run stopped early" },
  { key: "failed", label: "Could not be read" },
];
